module.exports = __webpack_public_path__ + "img/ve.3af86393.svg";